import axios from 'axios';
import { toast } from 'react-toastify';

const api = axios.create({
  // Relative by default: in the cloud, CloudFront serves the SPA and proxies
  // /api/* to the backend (same origin) — so ONE build works in every
  // environment. Local dev overrides via .env.development / compose build arg.
  baseURL: process.env.REACT_APP_API_URL || '/api/v1',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

// Response interceptor — global error handling
api.interceptors.response.use(
  res => res,
  err => {
    const status  = err.response?.status;
    const message = err.response?.data?.message || 'Something went wrong';

    if (status === 401) {
      localStorage.removeItem('ei_token');
      window.location.href = '/login';
      return Promise.reject(err);
    }
    if (status === 403) toast.error('You do not have permission to do that.');
    if (status === 429) toast.error('Too many requests — please wait a moment.');
    if (status >= 500) toast.error('Server error — please try again shortly.');
    if (status === 422) { /* Let forms handle validation errors */ }
    if (status !== 401 && status !== 422 && status < 500) {
      // 4xx client errors — show message
    }

    return Promise.reject({ ...err, userMessage: message });
  }
);

export default api;
